// extracted by mini-css-extract-plugin
module.exports = {"container":"MediaExtraMaterials_container__iRSB5"};